import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 MATRIZ DE ENCUESTA

    Varias filas, la misma escala en todas. Es lo que se usa cuando hay
    que calificar seis aspectos: seis campos sueltos ocupan media
    pantalla y se leen peor que una grilla.

    El valor es { filaId: valorElegido }.

    ⚠️ En mobile una grilla de 5 columnas no entra: cada fila se
       convierte en su propio bloque con la escala debajo.
*/

export const FieldMatrix = ({
    id, label, hint, error,
    rows = [], scale = [], value = {}, onChange,
    isRequired = false, isDisabled = false, span = 2,
}) => {

    const onPick = (rowId, scaleValue) => onChange?.({ ...value, [rowId]: scaleValue });

    const ANSWERED = rows.filter((row) => value[row.value] !== undefined).length;

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span}
            isRequired={isRequired} isDisabled={isDisabled}
            hint={hint ?? `${ANSWERED} de ${rows.length} respondidas`} >

            <div className={`${BLOCK}__matrix`} style={{ '--LS__matrix_cols': scale.length }}>

                <div className={`${BLOCK}__matrix_head`}>
                    <span className={`${BLOCK}__matrix_corner`} />
                    {scale.map((s) => <span key={s.value} className={`${BLOCK}__matrix_col`}>{s.label}</span>)}
                </div>

                {
                    rows.map((row) => (
                        <div key={row.value} className={`${BLOCK}__matrix_row`} role="radiogroup">

                            <span className={`${BLOCK}__matrix_label`}>{row.label}</span>

                            {
                                scale.map((s) => (
                                    <label key={s.value} className={`${BLOCK}__matrix_cell`}
                                        data-on={value[row.value] === s.value}
                                        title={`${row.label}: ${s.label}`} >

                                        <input type="radio" name={`${id}_${row.value}`}
                                            className={`${BLOCK}__check_input`}
                                            checked={value[row.value] === s.value}
                                            onChange={() => onPick(row.value, s.value)}
                                            disabled={isDisabled} />

                                        <span className={`${BLOCK}__radio_box`} aria-hidden="true">
                                            <span className={`${BLOCK}__radio_dot`} />
                                        </span>

                                        {/* Solo se ve en mobile, cuando la cabecera desaparece */}
                                        <span className={`${BLOCK}__matrix_cell_label`}>{s.label}</span>

                                    </label>
                                ))
                            }

                        </div>
                    ))
                }

            </div>

        </FieldShell>
    );
};
